import * as TE from 'fp-ts/es6/TaskEither'
import * as T from 'fp-ts/es6/Task'

export class TooManyPollAttemptsError extends Error {
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(message: string) {
    super(message)
  }

  // eslint-disable-next-line @typescript-eslint/prefer-as-const
  __typename: 'TooManyPollAttemptsError' = 'TooManyPollAttemptsError'
}

export function poll<L, R>(
  action: TE.TaskEither<L, R>,
  bufferDurationMillis: number,
  maxAttempts: number,
  successPredicate: (r: R) => boolean,
): TE.TaskEither<L | TooManyPollAttemptsError, R> {
  const apply = (te: TE.TaskEither<L, R>, remainingAttempts: number): TE.TaskEither<L | TooManyPollAttemptsError, R> => {
    return TE.chain((r: R) => {
      if (successPredicate(r)) {
        return TE.right(r)
      }
      if (remainingAttempts === 0) {
        return TE.left(new TooManyPollAttemptsError('Too many poll attempts.'))
      }
      return T.delay(bufferDurationMillis)(apply(action, remainingAttempts - 1))
    })(te)
  }

  return apply(action, maxAttempts - 1)
}

export function retry<L, R>(action: TE.TaskEither<L, R>, bufferDurationMillis: number, maxAttempts: number): TE.TaskEither<L, R> {
  const apply = (te: TE.TaskEither<L, R>, remainingAttempts: number): TE.TaskEither<L, R> => {
    return TE.orElse((l: L) => {
      if (remainingAttempts === 0) {
        return TE.left(l)
      }
      return T.delay(bufferDurationMillis)(apply(action, remainingAttempts - 1))
    })(te)
  }

  return apply(action, maxAttempts - 1)
}
